/* Nightpass - Nighty (conseiller IA) */
(function () {
  var API = 'https://nightpass-chat-nightpass-projects1.vercel.app/api/chat';
  var AVATAR = (window.NP_NIGHTY_AVATAR || '').trim();
  var MOBILE = '(max-width: 989px)';
  var BAR_KEY = 'np_bar_closed';
  /* Tant que l'API n'est pas en ligne, c'est le seul chemin emprunte :
     autant que Nighty le dise gentiment plutot que de parler de connexion. */
  var BIENTOT = "Oups, je ne suis pas encore disponible ! J'arrive avec la prochaine version de la boutique \u2014 d'ici l\u00e0, les rayons vous attendent.";
  var SUGGESTIONS = [
    'Un panier vers 100 \u20ac pour ma soir\u00e9e rose',
    'Anniversaire des 14 ans de mon fils, tu conseilles quoi ?',
    'Une d\u00e9co compl\u00e8te Halloween, le moins cher possible'
  ];

  var history = [];
  var busy = false;
  var els = {};

  function icon(paths, size) {
    return '<svg viewBox="0 0 24 24" width="' + (size || 20) + '" height="' + (size || 20) + '" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + '</svg>';
  }
  var ICON_SPARK = icon('<path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"/><path d="M18.5 15.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z"/>');
  var ICON_CLOSE = icon('<path d="M6 6l12 12M18 6L6 18"/>', 18);
  var ICON_SEND = icon('<path d="M4.5 12h14M12 5.5l6.5 6.5L12 18.5"/>', 18);
  var ICON_CART = icon('<path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.4a2 2 0 0 0 2-1.55L20 8H6"/><circle cx="9.5" cy="19" r="1.4"/><circle cx="17" cy="19" r="1.4"/>', 17);

  function isMobile() { return window.matchMedia(MOBILE).matches; }

  function avatarMarkup(cls) {
    if (AVATAR) return '<img class="' + cls + ' ' + cls + '--img" src="' + AVATAR + '" alt="Nighty" loading="lazy">';
    return '<span class="' + cls + '">' + ICON_SPARK + '</span>';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n) {
    return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' \u20ac';
  }

  function build() {
    if (document.querySelector('.np-chat')) return;

    var veil = document.createElement('div');
    veil.className = 'np-chat-veil';
    veil.setAttribute('data-open', '0');

    var panel = document.createElement('aside');
    panel.className = 'np-chat';
    panel.setAttribute('data-open', '0');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Nighty, conseiller Nightpass');
    panel.innerHTML =
      '<div class="np-chat__head">' +
        avatarMarkup('np-chat__mark') +
        '<div class="np-chat__titles">' +
          '<p class="np-chat__title">Nighty</p>' +
          '<p class="np-chat__sub">Votre complice de soir\u00e9e</p>' +
        '</div>' +
        '<button type="button" class="np-chat__close" aria-label="Fermer">' + ICON_CLOSE + '</button>' +
      '</div>' +
      '<div class="np-chat__body" data-np-body></div>' +
      '<div class="np-chat__foot">' +
        '<div class="np-chat__form">' +
          '<textarea class="np-chat__input" rows="1" placeholder="Votre f\u00eate, vos invit\u00e9s, votre budget..." aria-label="Votre message"></textarea>' +
          '<button type="button" class="np-chat__send" aria-label="Envoyer">' + ICON_SEND + '</button>' +
        '</div>' +
        '<p class="np-chat__legal">Nighty est un assistant automatique \u2014 v\u00e9rifiez les articles avant de commander.</p>' +
      '</div>';

    document.body.appendChild(veil);
    document.body.appendChild(panel);

    els = {
      veil: veil,
      panel: panel,
      body: panel.querySelector('[data-np-body]'),
      input: panel.querySelector('.np-chat__input'),
      send: panel.querySelector('.np-chat__send')
    };

    veil.addEventListener('click', close);
    panel.querySelector('.np-chat__close').addEventListener('click', close);
    els.send.addEventListener('click', submit);
    els.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(); }
    });
    els.input.addEventListener('input', function () {
      els.input.style.height = 'auto';
      els.input.style.height = Math.min(els.input.scrollHeight, 120) + 'px';
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.getAttribute('data-open') === '1') close();
    });

    greet();
  }

  /* ---------- Point d'entree : icone du header (ordinateur) ---------- */
  function addButton() {
    if (isMobile()) return;
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.np-chat-open')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'np-chat-open';
    btn.setAttribute('aria-label', 'Demander \u00e0 Nighty');
    btn.innerHTML = avatarMarkup('np-chat-open__face');
    btn.addEventListener('click', open);
    var search = icons.querySelector('details-modal, .header__icon--search');
    if (search && search.parentNode === icons) icons.insertBefore(btn, search);
    else icons.insertBefore(btn, icons.firstChild);
  }

  /* ---------- Point d'entree : bandeau bas (mobile et tablette) ---------- */
  function addBar() {
    if (!isMobile()) return;
    if (document.querySelector('.np-chat-bar') || document.querySelector('.np-chat-fab')) return;

    var closed = false;
    try { closed = window.sessionStorage.getItem(BAR_KEY) === '1'; } catch (e) {}

    if (closed) { addFab(); return; }

    var bar = document.createElement('div');
    bar.className = 'np-chat-bar';
    bar.innerHTML =
      avatarMarkup('np-chat-bar__face') +
      '<div class="np-chat-bar__text">' +
        '<p class="np-chat-bar__title">Besoin d\'un coup de main ?</p>' +
        '<p class="np-chat-bar__sub">Nighty compose votre panier en 30 s</p>' +
      '</div>' +
      '<button type="button" class="np-chat-bar__cta">Discuter</button>' +
      '<button type="button" class="np-chat-bar__x" aria-label="Masquer">' + ICON_CLOSE + '</button>';

    document.body.appendChild(bar);
    document.body.classList.add('np-has-bar');

    bar.querySelector('.np-chat-bar__cta').addEventListener('click', open);
    bar.querySelector('.np-chat-bar__face').addEventListener('click', open);
    bar.querySelector('.np-chat-bar__text').addEventListener('click', open);
    bar.querySelector('.np-chat-bar__x').addEventListener('click', function (e) {
      e.stopPropagation();
      try { window.sessionStorage.setItem(BAR_KEY, '1'); } catch (err) {}
      bar.remove();
      document.body.classList.remove('np-has-bar');
      addFab();
    });

    requestAnimationFrame(function () { bar.setAttribute('data-in', '1'); });
  }

  function addFab() {
    if (!isMobile() || document.querySelector('.np-chat-fab')) return;
    var fab = document.createElement('button');
    fab.type = 'button';
    fab.className = 'np-chat-fab';
    fab.setAttribute('aria-label', 'Demander \u00e0 Nighty');
    fab.innerHTML = avatarMarkup('np-chat-fab__face');
    fab.addEventListener('click', open);
    document.body.appendChild(fab);
  }

  function open() {
    build();
    els.veil.setAttribute('data-open', '1');
    els.panel.setAttribute('data-open', '1');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { els.input.focus(); }, 280);
  }
  function close() {
    if (!els.panel) return;
    els.veil.setAttribute('data-open', '0');
    els.panel.setAttribute('data-open', '0');
    document.body.style.overflow = '';
  }

  function scroll() { els.body.scrollTop = els.body.scrollHeight; }

  function bubble(role, text) {
    var wrap = document.createElement('div');
    wrap.className = 'np-msg np-msg--' + role;
    if (role === 'bot') {
      wrap.innerHTML =
        '<div class="np-msg__row">' +
          avatarMarkup('np-msg__face') +
          '<div class="np-msg__stack"><p class="np-msg__bubble">' + esc(text) + '</p></div>' +
        '</div>';
    } else {
      wrap.innerHTML = '<p class="np-msg__bubble">' + esc(text) + '</p>';
    }
    els.body.appendChild(wrap);
    scroll();
    return wrap.querySelector('.np-msg__stack') || wrap;
  }

  function greet() {
    var stack = bubble('bot', 'Salut, moi c\'est Nighty ! Dites-moi quelle f\u00eate vous pr\u00e9parez, pour combien de personnes et votre budget \u2014 je vous compose une s\u00e9lection.');
    var chips = document.createElement('div');
    chips.className = 'np-chat-chips';
    SUGGESTIONS.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'np-chat-chip';
      b.textContent = s;
      b.addEventListener('click', function () { chips.remove(); send(s); });
      chips.appendChild(b);
    });
    stack.appendChild(chips);
    scroll();
  }

  function cards(stack, products, total) {
    if (!products || !products.length) return;
    var box = document.createElement('div');
    box.className = 'np-chat-cards';

    products.forEach(function (p) {
      var card = document.createElement('div');
      card.className = 'np-chat-card';
      card.innerHTML =
        (p.image
          ? '<img class="np-chat-card__img" src="' + esc(p.image) + '" alt="" loading="lazy" width="54" height="54">'
          : '<span class="np-chat-card__img"></span>') +
        '<div class="np-chat-card__info">' +
          '<a class="np-chat-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="np-chat-card__meta">' +
            '<span class="np-chat-card__price">' + money(p.price * p.qty) + '</span>' +
            '<span class="np-chat-card__qty">\u00d7 ' + p.qty + '</span>' +
          '</div>' +
          (p.why ? '<span class="np-chat-card__why">' + esc(p.why) + '</span>' : '') +
        '</div>';
      box.appendChild(card);
    });

    if (total) {
      var t = document.createElement('div');
      t.className = 'np-chat-total';
      t.innerHTML = '<span>Total de la s\u00e9lection</span><strong>' + money(total) + '</strong>';
      box.appendChild(t);
    }

    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'np-chat-add';
    add.innerHTML = ICON_CART + '<span>Ajouter au panier</span>';
    add.addEventListener('click', function () { addAll(products, add); });
    box.appendChild(add);

    stack.appendChild(box);
    scroll();
  }

  function addAll(products, btn) {
    btn.disabled = true;
    btn.querySelector('span').textContent = 'Ajout en cours...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: products.map(function (p) { return { id: p.variant_id, quantity: p.qty }; })
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        btn.querySelector('span').textContent = 'Ajout\u00e9 \u2014 voir le panier';
        btn.disabled = false;
        btn.onclick = function () { window.location.href = '/cart'; };
      })
      .catch(function () {
        btn.disabled = false;
        btn.querySelector('span').textContent = 'Ajout impossible \u2014 r\u00e9essayer';
      });
  }

  function submit() {
    var text = (els.input.value || '').trim();
    if (!text) return;
    els.input.value = '';
    els.input.style.height = 'auto';
    send(text);
  }

  function send(text) {
    if (busy) return;
    busy = true;
    els.send.disabled = true;

    bubble('user', text);
    history.push({ role: 'user', content: text });

    var waiting = document.createElement('div');
    waiting.className = 'np-msg np-msg--bot';
    waiting.innerHTML =
      '<div class="np-msg__row">' + avatarMarkup('np-msg__face') +
      '<div class="np-msg__stack"><p class="np-msg__bubble"><span class="np-chat-dots"><span></span><span></span><span></span></span></p></div></div>';
    els.body.appendChild(waiting);
    scroll();

    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: history })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        waiting.remove();
        var reply = data.reply || "Je n'ai pas de r\u00e9ponse pour le moment.";
        var stack = bubble('bot', reply);
        history.push({ role: 'assistant', content: reply });
        cards(stack, data.products, data.total);
      })
      .catch(function () {
        waiting.remove();
        bubble('bot', BIENTOT);
      })
      .then(function () {
        busy = false;
        els.send.disabled = false;
        scroll();
      });
  }

  window.NightyAsk = function (text) {
    open();
    if (!text) return;
    var chips = document.querySelector('.np-chat-chips');
    if (chips) chips.remove();
    setTimeout(function () { send(String(text)); }, 60);
  };
  window.NightyOpen = open;

  function init() {
    addButton();
    addBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);

  /* Rotation de l'appareil : on bascule le bon point d'entree */
  window.addEventListener('resize', function () {
    if (isMobile()) {
      var headBtn = document.querySelector('.np-chat-open');
      if (headBtn) headBtn.remove();
      addBar();
    } else {
      var bar = document.querySelector('.np-chat-bar');
      var fab = document.querySelector('.np-chat-fab');
      if (bar) bar.remove();
      if (fab) fab.remove();
      document.body.classList.remove('np-has-bar');
      addButton();
    }
  });
})();
